import { defineComponent } from '@vue/composition-api';
// `img` is a Font Awesome icon name and must exist in the stylesheet that
// public/index.html actually loads, which is Font Awesome 6.5.2 *Free*.
// 'calendar-image' and 'alarm-clock' are Pro-only names: the free stylesheet
// defines no rule for them at all, so those two cards rendered an empty <i>
// while 'handshake' and 'laptop' rendered a 10em-tall line box -- which is why
// the row started its heading at two different heights. The style class was
// `fa-thin`, also Pro-only and likewise undefined in the free stylesheet, so
// no icon font was ever selected for any of the four.
const blocks = [
    {
        img: 'handshake',
        name: 'connect'
    },
    {
        img: 'laptop',
        name: 'in_charge_of_account'
    },
    {
        img: 'calendar-check',
        name: 'no_double_booking'
    },
    {
        img: 'clock',
        name: 'book_directly'
    }
];
export default defineComponent({
    setup() {
        return {
            blocks
        };
    }
});
